import BaseForm from './BaseForm.vue';

export default BaseForm;

export { BaseForm };
